import { ChannelLabel } from '../../types';

import { LegendInfo, QualityColor, QualityColorKey, QualityType, SignalPointInfo } from './types';

export const legendInfo: Record<QualityType, LegendInfo> = {
  SQI: {
    labels: {
      GOOD: '71~100',
      NOT_BAD: '51~70',
      BAD: '21~50',
      ERROR: '0~20',
      NO_SIGNAL: '연결안됨',
    },
    title: 'SQI (Dry Standard)',
    toColor: (value: number | undefined) => {
      if (value !== undefined) {
        if (value >= 71) {
          return QualityColor.GOOD;
        } else if (value >= 51) {
          return QualityColor.NOT_BAD;
        } else if (value >= 21) {
          return QualityColor.BAD;
        }
        return QualityColor.ERROR;
      }

      return QualityColor.NO_SIGNAL;
    },
  },
  IMPEDANCE: {
    labels: {
      GOOD: '0~100',
      NOT_BAD: '101~5K',
      BAD: '5K~10K',
      ERROR: '10K~',
      NO_SIGNAL: '연결안됨',
    },
    title: 'Impedance (Dry Standard)',
    toColor: (value: number | undefined) => {
      if (value !== undefined) {
        if (value <= 100) {
          return QualityColor.GOOD;
        } else if (value <= 5000) {
          return QualityColor.NOT_BAD;
        } else if (value <= 10000) {
          return QualityColor.BAD;
        }
        return QualityColor.ERROR;
      }

      return QualityColor.NO_SIGNAL;
    },
  },
};

export const toQualityColorKeys = (values: Record<QualityColorKey, any>) => {
  return Object.keys(values).map((v) => v as QualityColorKey);
};

export const signalPoints: SignalPointInfo[] = [
  {
    label: ChannelLabel.Fp1,
    leftRatio: 0.344,
    topRatio: 0.155,
  },
  {
    label: ChannelLabel.Fp2,
    rightRatio: 0.344,
    topRatio: 0.155,
  },
  {
    label: ChannelLabel.F7,
    leftRatio: 0.142,
    topRatio: 0.285,
  },
  {
    label: ChannelLabel.F8,
    rightRatio: 0.142,
    topRatio: 0.285,
  },
  {
    label: ChannelLabel.F3,
    leftRatio: 0.289,
    topRatio: 0.319,
  },
  {
    label: ChannelLabel.F4,
    rightRatio: 0.289,
    topRatio: 0.319,
  },
  {
    label: ChannelLabel.Fz,
    leftRatio: 0.463,
    topRatio: 0.326,
  },
  {
    label: ChannelLabel.T3,
    leftRatio: 0.071,
    topRatio: 0.496,
  },
  {
    label: ChannelLabel.T4,
    rightRatio: 0.071,
    topRatio: 0.496,
  },
  {
    label: ChannelLabel.C3,
    leftRatio: 0.266,
    topRatio: 0.496,
  },
  {
    label: ChannelLabel.C4,
    rightRatio: 0.266,
    topRatio: 0.496,
  },
  {
    label: ChannelLabel.Cz,
    leftRatio: 0.463,
    topRatio: 0.496,
  },

  {
    label: ChannelLabel.T5,
    leftRatio: 0.142,
    bottomRatio: 0.217,
  },
  {
    label: ChannelLabel.T6,
    rightRatio: 0.142,
    bottomRatio: 0.217,
  },
  {
    label: ChannelLabel.P3,
    leftRatio: 0.289,
    bottomRatio: 0.249,
  },
  {
    label: ChannelLabel.P4,
    rightRatio: 0.289,
    bottomRatio: 0.249,
  },
  {
    label: ChannelLabel.Pz,
    leftRatio: 0.463,
    bottomRatio: 0.256,
  },
  {
    label: ChannelLabel.O1,
    leftRatio: 0.344,
    bottomRatio: 0.087,
  },
  {
    label: ChannelLabel.O2,
    rightRatio: 0.344,
    bottomRatio: 0.087,
  },
];
